import React from 'react';
import * as Ons from 'react-onsenui';
import PullHook from '../PullHook';
import Season from '../ListItems/Season';
import Toolbar from '../Toolbar';
import { translate as _ } from '../../util/i18n';
import { expired } from '../../util';

class Seasons extends React.Component {

    #pullHookCallback;

    constructor( props ) {

        // console.log( 'components.Seasons.constructor()', props );

        super( props );

        this.state = {
            pullHook:   'initial'
        };

        this.loadSeasons          = this.loadSeasons.bind( this );
        this.handlePullHookChange = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad   = this.handlePullHookLoad.bind( this );
        this.handleSelectSeason   = this.handleSelectSeason.bind( this );

    }

    componentDidMount() {

        expired( this.props.lastUpdate ) && this.loadSeasons();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            const cb = this.#pullHookCallback;

            setTimeout( () => cb(), 1000 );

            this.#pullHookCallback = null;

        }

    }

    loadSeasons() {

        this.props.onLoadSeasons( this.props.context, this.props.token );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.loadSeasons();

    }

    handleSelectSeason( season ) {

        this.props.onSelectSeason( season );
        this.props.onChangePage( { page: 'games' } );

    }

    render() {

        return (

            <Ons.Page renderToolbar={() => <Toolbar title={_( 'Saisonen' )} onMenuClick={this.props.onMenuClick} onReloadClick={this.loadSeasons} />}>

                <PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad} />

                {this.props.loading && this.state.pullHook !== 'action' && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                <h1 className="page-title">{_( 'Saisonen' )}</h1>

                {
                    this.props.seasons && this.props.seasons.length ?

                        <Ons.List
                            dataSource={this.props.seasons}
                            renderRow={( season, idx ) => <Season season={season} key={season.leagueId + '-' + season.id} modifier={idx === this.props.seasons.length - 1 ? 'longdivider' : null} onClick={this.handleSelectSeason} />}
                        />

                    : ! expired( this.props.lastUpdate ) &&

                        <div className="no-items">
                            <p>{_( 'Keine Saisonen gefunden.' )}</p>
                            <Ons.Button modifier="large" onClick={this.loadSeasons}>{_( 'Aktualisieren' )}</Ons.Button>
                        </div>
                }

            </Ons.Page>

        );

    }

}

export default Seasons;